import axios from "axios";
import { Buffer } from 'buffer';

var username = 'user';
var password = 'pass';
const token = `${username}:${password}`;
const encodedToken = Buffer.from(token).toString('base64');


const api = axios.create({
    baseURL: 'http://200.98.82.71:9000/',//'http://200.98.82.71:9000/',//'http://localhost:9000/',//'http://200.98.82.71:9070/dll_pontoequilibrio/servidor_dll.dll/',
    headers:{
        'Accept': 'application/json',
        'Content': 'application/json',
        'Authorization': 'Basic '+ encodedToken
    }

});

export default api